module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sprague L. de Camp, Lin Carter, Björn Nyberg\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("L. Sprague de Camp")]), _vm._v(", a SFWA Grand Master and winner of the World Fantasy Award for Life Achievement, wrote the definitive biography of Conan's creator, Robert E. Howard. De Camp died in 2000."), _c('br'), _c('br'), _c('B', [_vm._v("Lin Carter ")]), _vm._v("was the key figure behind the popular Ballantine Adult Fantasy Series of the 1970s. He died in 1988."), _c('br'), _c('br'), _c('B', [_vm._v("Björn")]), _vm._v(" Nyberg"), _vm._v(" first began collaborating with de Camp on Conan works in the 1950s. He lives in France.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/f0YBed/images/9781466834972.jpg?1726444428133",
      "alt": "This image is the cover for the book Conan the Swordsman"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Conan the Swordsman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Imagine a world of gods and demons, where men are warriors, women are beautiful, life is a fantastic adventure, and the fate of kingdoms balances on the bloody blade of a fabulous hero: Conan of the iron thews, the blue-eyed barbarian giant who towers above the savage Hyborian world."), _c('br'), _c('br'), _vm._v("This is the work that relaunched Conan in both the 1970s and 80s, back in print after more than a decade."), _c('br'), _c('br'), _vm._v("Come live the adventure again."), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    A Tom Doherty Associates Book\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0